import newChatAudio from '../assets/sounds/new-chat.mp3';
import newMessageAudio from '../assets/sounds/new-message.mp3';

// Create audio instances with imported files
const newChatSound = new Audio(newChatAudio);
const newMessageSound = new Audio(newMessageAudio);

export const playNewChatSound = () => {
  console.log('Playing new chat sound');
  newChatSound.currentTime = 0;
  newChatSound.volume = 0.5; // Set volume to 50%
  newChatSound.play().catch(err => console.log('Audio playback failed:', err));
};

export const playNewMessageSound = () => {
  console.log('Playing new message sound');
  newMessageSound.currentTime = 0;
  newMessageSound.volume = 0.5; // Set volume to 50%
  newMessageSound.play().catch(err => console.log('Audio playback failed:', err));
}; 